import { render, staticRenderFns } from "./PropertyMaintenanceSystemTabs.vue?vue&type=template&id=59d86dff"
import script from "./PropertyMaintenanceSystemTabs.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports